import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import ShopInterface from '../../api/ShopInterface';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseTypes } from '../../utils/routeParamConstants';
import { rewardTypes } from '../../utils/messageTypes';
import { PLATFORM } from '../../constants';
import utils from '../../utils';
import { getText, TEXT_KEY } from '../../utils/localization';
import AppInterface from '../../api/AppInterface';

var PurchaseSucceeded = /*#__PURE__*/function (_Component) {
  function PurchaseSucceeded() {
    var _this2;

    _classCallCheck(this, PurchaseSucceeded);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, PurchaseSucceeded, [].concat(args));
    _this2.goToVipLobbyHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.props.dismissModal();

              _this2.props.showVipAccessModal(false); // setting it to false to stop showing the pop up again.


              ShopInterface.refreshActiveConsumables();
              _context.next = 5;
              return _this2.props.getGameRooms(true);

            case 5:
              QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
              QueryParamsProxy.navigate(_this2.props.navigation, Screens.VIP);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this2.closeModal = function () {
      _this2.props.dismissModal();

      _this2.props.showVipAccessModal(true); // setting it back to true to show the pop up again.

    };

    _this2.getActiveRouteName = function () {
      var navigationState = _this2.props.navigation.state;
      if (utils.getPlatform() === PLATFORM.WEB) return navigationState.routes[navigationState.index].routeName;
      return navigationState.routeName;
    };

    return _this2;
  }

  _inherits(PurchaseSucceeded, _Component);

  return _createClass(PurchaseSucceeded, [{
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.getActiveRouteName() === Screens.Home)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return AppInterface.updateAppEvents();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var purchaseType = this.props.purchaseType;
      var vipPurchase = purchaseType === PurchaseTypes.VIP || purchaseType === rewardTypes.VIP_ROOM_ACCESS || purchaseType === PurchaseTypes.CONSUMABLE;
      var message;
      var buttonHandler;

      if (vipPurchase) {
        message = getText(TEXT_KEY.ENJOY_EXCLUSIVE_COLLECTION_MESSAGE);
        buttonHandler = this.goToVipLobbyHandler;
      } else {
        message = getText(TEXT_KEY.COINS_HAVE_BEEN_ADDED_MESSAGE);
        buttonHandler = this.closeModal;
      }

      return this.props.render({
        message: message,
        buttonHandler: buttonHandler,
        vipPurchase: vipPurchase
      });
    }
  }]);
}(Component);

export { PurchaseSucceeded as default };